import React from 'react'
import styles from './Skeleton.module.css'

interface SkeletonProps {
  width?: string | number
  height?: string | number
  borderRadius?: string | number
  className?: string
  variant?: 'text' | 'circular' | 'rectangular' | 'rounded'
  animation?: 'pulse' | 'wave' | 'shimmer'
}

export default function Skeleton({
  width,
  height,
  borderRadius,
  className = '',
  variant = 'text',
  animation = 'shimmer',
}: SkeletonProps) {
  const getVariantStyles = () => {
    switch (variant) {
      case 'circular':
        return { borderRadius: '50%' }
      case 'rounded':
        return { borderRadius: '0.42vw' }
      case 'rectangular':
        return { borderRadius: 0 }
      case 'text':
      default:
        return { borderRadius: '0.21vw' }
    }
  }

  const getAnimationClass = () => {
    switch (animation) {
      case 'pulse':
        return styles.pulse
      case 'wave':
        return styles.wave
      case 'shimmer':
      default:
        return styles.shimmer
    }
  }

  const style = {
    width: width,
    height: height,
    ...getVariantStyles(),
    ...(borderRadius && { borderRadius }),
  }

  return <div className={`${styles.skeleton} ${getAnimationClass()} ${className}`} style={style} />
}
